import React from 'react';
import { useSiteConfig } from '../../config';
import { alpha } from '@mui/material/styles';
import '../../../node_modules/@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import { useTranslate } from '@im/react-localization';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useBreakpoint } from '@im/ui-lib/zenith/responsive';
import { LoginLayoutZenith } from '../../auth/LoginLayoutZenith';
import { LoginWidget } from '../../auth/okta-widget-customizations/LoginWidget';

type Props = {
  children?: JSX.Element;
  primaryAuthTitle?: string;
};

const STARS_ICON_SIZE = 80;

export const LoginViewX4EC = ({
  children,
  primaryAuthTitle,
}: Readonly<Props>) => {
  const { storefrontInfo } = useSiteConfig();
  const translate = useTranslate();

  const { getBreakpoint } = useBreakpoint();
  const bp = getBreakpoint();
  const isMdBp = bp === 'md';
  const starsSpacing = window.innerHeight < 630 ? -32 : -48;

  return (
    <LoginLayoutZenith
      logo={
        <img
          alt={`${storefrontInfo?.displayName} logo`}
          height="40"
          src={storefrontInfo?.logo ?? '/xshared/assets/img/logo-ingram-blue'}
          width="auto"
        />
      }
      primaryAuthTitle={
        primaryAuthTitle ? primaryAuthTitle : translate('Login.WelcomeHeader')
      }
      splashContent={
        <Stack
          maxWidth={isMdBp ? '424px' : '536px'}
          minWidth={isMdBp ? '321px' : '407px'}
          pl={8}
          position="relative"
          pr={8}
        >
          <img
            alt="stars icon"
            height={STARS_ICON_SIZE}
            src="/x4ec/assets/img/login/login-stars.svg"
            style={{
              position: 'absolute',
              top: starsSpacing - STARS_ICON_SIZE,
            }}
            width={STARS_ICON_SIZE}
          />
          <Typography
            color="common.white"
            flexWrap="wrap"
            mb={6}
            variant={isMdBp ? 'display-lg-semibold' : 'display-xl-semibold'}
          >
            {translate('Login.SplashText')}
          </Typography>
          <Typography
            color="primary.100"
            flexWrap="wrap"
            variant="text-xl-bold"
          >
            {translate('Login.SplashSupportingText')}
          </Typography>
        </Stack>
      }
      splashSx={{
        backgroundImage: (theme) =>
          `linear-gradient(45deg, ${alpha(
            theme.palette.primary[900] ?? '',
            0.8
          )} 0%, ${alpha(
            theme.palette.primary[600] ?? '',
            0.8
          )} 80%), url('/x4ec/assets/img/login/login-splash.jpg')`,
      }}
    >
      {children ? children : <LoginWidget />}
    </LoginLayoutZenith>
  );
};
